import {createContext, useContext} from "react"

export interface FeatureSetting {
    key: string
    defaultValue: any
}

export type FeatureFlagsType<T extends readonly {key: string; defaultValue: any}[]> = {
    [K in T[number]["key"]]: T[number]["defaultValue"]
}

export const FeatureSettingsContext = createContext<any>(null)

/**
 * Creates the FeatureSettingsContext
 * @returns - The react context created for FeatureSettings.
 * @example
 * ```tsx
 * const ld = useFeatureSettingsContext<typeof featureFlags>()
 * ```
 */
export const useFeatureSettingsContext = <T extends readonly FeatureSetting[]>() => {
    return useContext<FeatureFlagsType<T>>(FeatureSettingsContext)
}
